export default function IsValidTotalHours(hours) {
  var re = /(?:([0-9]+h)$|([0-9]+m$)$|(?:[0-9]+h[0-9]+m$))/gi;
  return re.test(hours);
}
